import React from 'react';

export const IconCarretUpDown: React.FC<React.SVGAttributes<SVGElement>> = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={'1em'} height={'1em'} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M14.1665 14.167L10.8837 17.4498C10.3956 17.9379 9.60413 17.9379 9.11597 17.4498L5.83321 14.167"
        stroke={'currentColor'}
        strokeWidth="1.66667"
        strokeLinecap="round"
      />
      <path
        d="M5.8335 5.83301L9.11627 2.55022C9.60443 2.06207 10.3959 2.06207 10.884 2.55022L14.1668 5.83301"
        stroke={'currentColor'}
        strokeWidth="1.66667"
        strokeLinecap="round"
      />
    </svg>
  );
};
